import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.CREATE_SHIPPING_PARTNER.REQUEST, saga.createShippingPartner);
    yield takeLatest(ACTION.CREATE_SHIPPING_PARTNER.SUCCESS, saga.createShippingPartnerSuccess);
}
